document.addEventListener('DOMContentLoaded', function () {
    checkPopUpTime();
    handlePopUp();
});

window.addEventListener('CookiebotOnAccept', handlePopUp);

function checkPopUpTime() {
    let popupClosedTimestamp = localStorage.getItem('popupClosed');
    let twoHoursAgo = new Date().getTime() - (2 * 60 * 60 * 1000);

    if (popupClosedTimestamp) {
        if (twoHoursAgo > popupClosedTimestamp) {
            localStorage.removeItem('popupClosed');
        }
    }
}

function handlePopUp() {
    const popUp = document.querySelector('.modal-box');
    const popUpCloseBtns = document.querySelectorAll('.modal-box__close');
    let cookieConsent = ('; ' + document.cookie).split(`; CookieConsent=`).pop().split(';')[0];
    
    const isLive = document.querySelector('.-live');

    if (popUp && popUpCloseBtns.length > 0 && isLive) {
        if (!localStorage.getItem('popupClosed') && cookieConsent) {
            setTimeout(function () {
                if (popUp && popUp.innerHTML.trim().length > 0) {
                    popUp.style.display = 'block';
                    document.body.classList.add('modal-open');
                }
            }, 20000);
        }

        popUpCloseBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                popUp.style.display = 'none';
                document.body.classList.remove('modal-open');
                localStorage.setItem('popupClosed', Date.now())
            });
        });
    }
}
